module.exports = __webpack_public_path__ + "img/Billedbog_Reidar.4fe9b473.jpg";